<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-describedby="modal-title" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" [innerHTML]="body"></div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="login()">Log in</button>
  <button type="button" class="btn btn-primary" (click)="signUp()">Sign Up</button>
</div>
